import React from "react";
import styled from "styled-components";
import { Colors, TextFont } from "../../config";
import { Error } from "../../config/StyledComponents";
const checkboxCheck = require("../../assets/images/checkbox_check.png");
const checkboxCheckWhite = require("../../assets/images/checkbox_check_light.png");
const checkboxUncheck = require("../../assets/images/checkbox_uncheck.png");

const Checkbox = ({
  dark = true,
  label,
  isChecked,
  setIsChecked,
  disabled,
  size,
  fontSize,
  fontWeight,
  fontColor,
  helperText,
}) => {
  const handleCheckChange = () => {
    if (!disabled) {
      setIsChecked(!isChecked);
    }
  };
  return (
    <CheckboxErrWrap>
      <CheckboxContainer onClick={handleCheckChange} disabled={disabled}>
        {isChecked ? (
          <Icon
            size={size}
            src={dark ? checkboxCheck : checkboxCheckWhite}
            alt="check"
          />
        ) : (
          <Icon size={size} src={checkboxUncheck} alt="uncheck" />
        )}
        <TextFont
          fontColor={dark ? fontColor : Colors.white}
          fontSize={fontSize}
          fontWeight={fontWeight}
        >
          {label}
        </TextFont>
      </CheckboxContainer>
      {helperText && <Error>{helperText}</Error>}
    </CheckboxErrWrap>
  );
};

export default Checkbox;

const Icon = styled.img`
  width: ${(props) => (props.size ? props.size : "auto")};
  height: ${(props) => (props.size ? props.size : "auto")};
`;
const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => props.disabled && 0.5};
  width: fit-content;
`;
const CheckboxErrWrap = styled.div`
  display: flex;
  flex-direction: column;
`;
